import * as yup from 'yup'

const schema = yup.object().shape(
  {
    idLoteAtual: yup.string().required('Lote destino é obrigatório'),
    idPastoAtual: yup.string().required('Local destino é obrigatório'),
    idAnimal: yup
      .string()
      .test('animal-or-lote', 'Animal é obrigatório quando movimentar por animal', function (value) {
        const { idLoteOrigem } = this.parent
        if (!idLoteOrigem && !value) {
          return false
        }
        return true
      }),
    idLoteOrigem: yup
      .string()
      .test('lote-or-animal', 'Lote origem é obrigatório quando movimentar por lote', function (value) {
        const { idAnimal } = this.parent
        if (!idAnimal && !value) {
          return false
        }
        return true
      })
  },
  [['idAnimal', 'idLoteOrigem']]
)

export default schema
